import { Checkbox, Col, Form, Input, Row } from 'antd';
import { observer } from 'mobx-react-lite';

export const EmployeeFields = observer(() => {
  return (
    <>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item name="login" label="Логин" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="name" label="Имя" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name="password"
            label="Пароль"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={6}>
          <Form.Item name="blocked" valuePropName="checked">
            <Checkbox>Заблокирован</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
});
